/**
 * Copyright (c) 2021 - 2022, Kodit Doo
 * Created by kodit-marko on 29.12.2022.
 */

import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SelectItem } from 'primeng/api';
import { AbstractControl } from '@angular/forms';
import {
  PdvEvidencijeClient,
  PdvOpseg, PdvPeriod,
  PdvPeriodDto,
} from '@kodit/core/data-api';
import { PdvEvidencijaService } from '../../pdv-evidencija.service';

@Component({
  selector: 'kodit-pdv-period-dropdown',
  templateUrl: './pdv-period-dropdown.html',
  styleUrls: ['./pdv-period-dropdown.scss'],
})
export class PdvPeriodDropdownComponent implements OnInit, OnDestroy {
  /** Subs */
  private _subs: Subscription;

  /** Props */
  items: SelectItem[];
  pdvPeriodi: PdvPeriodDto[];

  /** I/O */
  @Input() formCtrl: AbstractControl | undefined;
  @Input() formCtrlId: string;
  @Input() parentCtrl: string;
  @Input() shouldDisable: boolean = false;

  constructor(
    private _client: PdvEvidencijeClient,
    private _service: PdvEvidencijaService
  ) {
    this._subs = new Subscription();
    this.items = [];
    this.formCtrl = undefined!;
    this.formCtrlId = 'pdv-period-dropdown';
    this.parentCtrl = 'body';
    this.pdvPeriodi = [];
  }

  ngOnInit() {
    this._load();
    this._subs.add(
      this._service.getOpseg.subscribe((res) => {
        if (res === null || this.pdvPeriodi.length === 0) {
          return;
        }
        this.formCtrl!.patchValue(null);

        if (res === PdvOpseg.KVARTALNO) {
          this._setKvartalni();
        } else {
          this._setMesecni();
        }
      })
    );
  }

  private _load() {
    this._subs.add(
      this._client.getPdvPeriodDropdown().subscribe((res) => {
        if (!res.succeeded) {
          return;
        }
        this.pdvPeriodi = res.data!.responseList!;

        if (this.formCtrl?.value > PdvPeriod.DECEMBAR) {
          this._setKvartalni();
        } else {
          this._setMesecni();
        }
      })
    );
  }

  private _setMesecni() {
    this.items = this.pdvPeriodi
      .filter((x) => x.opseg === PdvOpseg.MESECNO)
      .map((x) => ({
        value: x.period,
        label: x.periodStr,
        title: x.opis,
      }));
  }

  private _setKvartalni() {
    this.items = this.pdvPeriodi
      .filter((x) => x.opseg === PdvOpseg.KVARTALNO)
      .map((x) => ({
        value: x.period,
        label: x.periodStr,
        title: x.opis,
      }));
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }
}
